// extracted by mini-css-extract-plugin
export var authors = "author-images-module--authors--MO6VA";
export var avatar = "author-images-module--avatar--efcz+";
export var avatarImg = "author-images-module--avatarImg--MKrwt";
export var avatars = "author-images-module--avatars--Al7MX";
export var mediaBody = "author-images-module--mediaBody--eT--t";
export var root = "author-images-module--root--1+EcW";